import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/oncology")({
  // Specialty gate: only users whose login payload grants the ONCOLOGY feature
  // may reach these pages. The sidebar hides the section for everyone else; this
  // guard stops the URLs being reached directly.
  beforeLoad: ({ context }) => {
    if (!context.auth.user?.features?.includes("ONCOLOGY")) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: OncologyLayout,
})

function OncologyLayout() {
  return <Outlet />
}
